var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPagination(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#353A3D;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8,23.5L8,23.5c0.6,0.6,1.6,0.6,2.2,0l0,0l10.6-10.6c0.5-0.5,0.5-1.3,0-1.8L10.3,0.5c-0.6-0.6-1.6-0.6-2.2,0 l0,0l0,0C7.4,1.1,7.4,2.1,8,2.8l0,0l9.2,9.2l-9.3,9.3C7.4,21.9,7.4,22.9,8,23.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPagination);
export default __webpack_public_path__ + "static/media/icon-pagination.b604044d.svg";
export { ForwardRef as ReactComponent };